export default __webpack_public_path__ + "static/media/geo-link.f200f8e7.png";